// extracted by mini-css-extract-plugin
export default {"image":"Benefits_image__Lh45U","list":"Benefits_list__gNwIW"};